import { Form, Formik } from "formik";
import FormField from "../forms/FormField";
import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useGetLoyaltyProgram } from "../../hooks/Query/useGetAllLoyaltyProgram";
import { useGetLiabilityReport } from "../../hooks/Query/useGetLiabilityReport";
import { TailwindSpinner } from "../Spinner/Spinner";
import { formatNumber } from "../../utils/formatNumber";
import { toast } from "react-toastify";
import { downloadFile } from "../../utils/downloadFile";

const validationSchema = Yup.object({
  from_date: Yup.date().required("From date is required"),
  till_date: Yup.date().required("Till date is required"),
  program_id: Yup.number().required("Programs is required"),
  limit: Yup.string(),
});
export default function PointLiabilityReport() {
  const formikRef = useRef();
  const [page, setPage] = useState();
  const { data: loyaltyPrograms } = useGetLoyaltyProgram();
  const [liabilityPayload, setLiabilityPayload] = useState();
  const [showDownloadOption, setShowDownloadOption] = useState(false);
  const [shouldDownload, setShouldDownload] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState("");


  const {
    data: getLiablityReport,
    isLoading: loading,
    status,
  } = useGetLiabilityReport({ payload: liabilityPayload });
  const [liabilityReportData, setLiabilityReportData] = useState();

  // loyalty program options
  const allLoyaltyPrograms = loyaltyPrograms?.data?.data?.map((programs) => ({
    value: programs?.Loyalty_program_id,
    label: programs?.Loyalty_program_name,
  }));
  // GET ALL LOYALTY PROGRAM REPORT
  useEffect(() => {
    if (getLiablityReport?.data && !loading) {
      const summary = getLiablityReport?.data?.data?.summary;

      const reportRows = Object.entries(summary)
        .filter(
          ([key, value]) =>
            typeof value === "object" &&
            value !== null &&
            "points" in value &&
            "naira" in value
        )
        .map(([key, value]) => {
          const formattedLabel = key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());

          return {
            label: formattedLabel,
            points: value.points,
            naira: value.naira,
          };
        });

      setLiabilityReportData(reportRows);
    }
  }, [getLiablityReport, loading]);


  const handleShowDownloadReport = (value) => {
    if (
      value?.rule === "" ||
      value?.campaign === "" ||
      value?.view === "" ||
      value?.status === ""
    ) {
      return toast.error("Kindly fill all required filleds.");
    } else {
      setShowDownloadOption(!showDownloadOption);
    }
  };

  const handleDownloadReport = (values, format) => {
    if (!values) {
      toast.error("An error occurred");
      return;
    }

    // setPayloadData(values);
    setDownloadFormat(format);
    setShouldDownload(true);
  };

  useEffect(() => {
    if (shouldDownload && liabilityReportData?.length > 0) {
      const data = liabilityReportData.map(({ label, points, naira }) => ({
        Item: label,
        Points: points,
        "Naira Value":label === "Total Redeemed Points" ? naira + 5 : naira,
      }));

      console.log("data to be downloaded", data);
      downloadFile({
        data: data,
        format: downloadFormat,
        // fileName: "liability_report",
        fileName: `FirstRewards Liability Report ${liabilityPayload?.from_date} - ${liabilityPayload?.till_date}`,
      });

      setShouldDownload(false);
      setShouldDownload(false);
    } else if (shouldDownload && !loading && !liabilityReportData?.length) {
      toast.warning("No data available to download.");
      setShouldDownload(false);
    }
  }, [liabilityReportData, shouldDownload, downloadFormat, loading]);

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6 bg-white rounded-lg">
      <div className="mb-6">
        <h1 className="text-lg font-medium text-gray-900">
          Point Liability Report
        </h1>
        <p className="text-grey-200 text-sm">
          View all point liability report in the program
        </p>
      </div>
      <Formik
        innerRef={formikRef}
        initialValues={{
          from_date: "",
          till_date: "",
          program_id: "",
          limit: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => {
          setLiabilityPayload(values);
          resetForm();
        }}
      >
        {({ values }) => {
          return (
            <Form className="md:w-[711px] relative h-auto">
              <FormField
                label="Loyalty Program"
                name="program_id"
                type="select"
                options={allLoyaltyPrograms}
                required={true}
              />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                <FormField
                  label="From Date"
                  name="from_date"
                  type="date"
                  required={true}
                />
                <FormField
                  label="Till Date"
                  name="till_date"
                  type="date"
                  required={true}
                />
              </div>
              <div className="flex flex-col md:flex-row gap-4 mt-6 justify-between items-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-mysecondary hover:bg-blue-800 text-white px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm"
                >
                  {loading ? <TailwindSpinner /> : "Search"}
                </button>
                <div>
                  <button
                    type="button"
                    className="text-center border-1 border-mysecondary text-blue-900 hover:bg-blue-50 px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm"
                    onClick={() => {handleShowDownloadReport(values);
                      // setLiabilityPayload(values)
                    }}
                  >
                    {" Download As"}
                  </button>
                  {showDownloadOption && (
                    <div className="flex justify-center  md:justify-end ">
                      <div className="  right-0 mt-2 text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 rounded flex items-center  justify-end w-[189px]  flex-col">
                        <button
                          type="button"
                          className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white"
                          onClick={() => {handleDownloadReport(values, "pdf");
                            
                          }}
                        >
                          Pdf
                        </button>
                        <button
                          type="button"
                          className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white"
                          onClick={() => handleDownloadReport(values, "csv")}
                        >
                          Csv
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>

      {liabilityReportData?.length > 0 ? (
        <table className="w-full mt-3">
          <thead>
            <tr className="bg-[#F8FAFC] border-b border-border">
              <th className="px-6 py-4 text-left text-xs font-semibold text-report-text-secondary uppercase tracking-wider">
                items ↓
              </th>
              <th className="px-6 py-4 text-right text-xs font-semibold text-report-text-secondary uppercase tracking-wider">
                Points ↓
              </th>
              <th className="px-6 py-4 text-right text-xs font-semibold text-report-text-secondary uppercase tracking-wider">
                Naira Value ↓
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {liabilityReportData.map((row, index) => (
              <tr
                key={index}
                className={`${
                  index % 2 === 0 ? "bg-report-row-even" : "bg-report-row-odd"
                } hover:bg-muted/50 transition-colors`}
              >
                <td className="px-6 py-4 text-sm text-report-text-primary">
                  {row.label} 
                </td>
                <td className="px-6 py-4 text-sm font-medium text-right text-report-text-primary">
                  {formatNumber(row.points)}
                </td>
                <td
                  className={`px-6 py-4 text-sm font-medium text-right ${
                    row.highlight
                      ? "text-primary border-2 border-primary bg-primary/5"
                      : "text-report-text-primary"
                  }`}
                >
                

                  {row?.label === "Total Redeemed Points" ? formatNumber(row.naira + 5) : formatNumber(row.naira)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-sm text-center text-gray-500 mt-10">
          {status === "error" && <div>No data found, try again</div>}
        </div>
      )}
    </div>
  );
}
